import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Link from '@UI/Link';
import styles from './FooterBanner.module.css';

import type { FC, HTMLAttributes } from 'react';

type FooterBannerProps = HTMLAttributes<HTMLDivElement>;

const FooterBanner: FC<FooterBannerProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();

  return (
    <div className={cn(styles.main, className)}>
      <h1 className={styles.title}>{t('footer.title')}</h1>
      <Link underlined view='primary' to='/category/promo-dofamin' className={styles.link}>
        {t('footer.link')}
      </Link>
    </div>
  );
};

export default FooterBanner;
